import { coerceCalendarDate } from "./calendarDateKey";

export const formatSourceCitationDate = (value) => {
  const date = coerceCalendarDate(value);
  return date
    ? date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";
};
